import _ from "lodash";
import { FILTER_DATE, CURRENT } from "../../constants/ordersFilter";
import { getOrderStatusLabel } from '../../utils'


export type Filters = {
    status: string[]
    date: string;
};


export const isWithinDate = (orderDate: string, filter: string) => {
    if (!filter) return true;

    const now = new Date();
    const date = new Date(orderDate);

    switch (filter) {
        case FILTER_DATE.TODAY:
            return date.toDateString() === now.toDateString();

        case FILTER_DATE.WEEK: {
            const lastWeek = new Date();
            lastWeek.setDate(now.getDate() - 7);
            return date >= lastWeek;
        }

        case FILTER_DATE.MONTH: {
            const lastMonth = new Date();
            lastMonth.setDate(now.getDate() - 30);
            return date >= lastMonth;
        }

        default:
            return true;
    }
};


export const filterOrders = (
    ordersList: any[],
    filters: Filters,
    isPast
) => {
    return _.filter(ordersList, (order) => {
        const { status } = getOrderStatusLabel(order, false, isPast);
        if (filters.status.includes(CURRENT) && !isPast) {
            return true;
        }

        if (
            filters.status.length &&
            !filters.status.includes(status)
        ) {
            return false;
        }

        if (!isWithinDate(order.date, filters.date)) return false;

        return true;
    });
};

export const getFilteredCurrentOrders = (
    orders: any[],
    filters: Filters,
    filterOrders: Function
) => {
    return filterOrders(orders || [], filters, false);
};

export const getFilteredPastOrders = (
    pastOrders: any,
    canceledOrders: any,
    filters: Filters,
    filterOrders: Function
) => {
    const allPast = [
        ..._.values(pastOrders ?? {}),
        ..._.values(canceledOrders ?? {}),
    ];

    return filterOrders(allPast, filters, true);
};